import { css as _css } from "@emotion/react";
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import IconCopy from '~icons/akar-icons/copy';
import { theme } from '@arc/frontend/ui-theme';
import { useCallout } from './Callout';
export function CopyToClipboardButton({
  value,
  className
}) {
  const {
    t
  } = useTranslation('common');
  const buttonRef = useRef(null);
  const {
    callout: clipboardCallout,
    setShowViewCallout: showClipboardCallout
  } = useCallout({
    text: t('clipboardCopied')
  });
  const onClick = async event => {
    // event.currentTarget changes to null after an await so we must save its
    // value to a const.
    const target = event.currentTarget;
    try {
      await navigator.clipboard.writeText(value);
      showClipboardCallout({
        target
      });
    } catch (err) {
      console.error('Error copying:', err);
    }
  };
  return <button ref={buttonRef} type="button" css={/*#__PURE__*/_css({
    color: theme.colors.lightBlue
  }, process.env.NODE_ENV === "production" ? "" : ";label:CopyToClipboardButton;")} className={className} onClick={onClick}>
			<IconCopy width={22} height={22} />
			{clipboardCallout}
		</button>;
}